import { AvatarProfile } from "components/AvatarProfile";
import React from "react";

export const PrivacySection = () => {
  return (
    <div className="container-lg relative my-16 md:my-160">
      <div className="md:grid md:grid-flow-row-dense md:grid-cols-2 md:items-center md:gap-32">
        <div className="relative -mx-4 mt-10 md:mt-0">
          <img
            className="relative mx-auto"
            width={544}
            src="/assets/product/product-and-terminal.png"
            alt=""
          />
        </div>
        <div className="sm:ml-40 md:ml-100">
          <h3 className="font-display text-32-40">
            <span className="text-gray-600">
              It’s your data —<br />
            </span>
            <span className="text-gray-900">Keep it secret, keep it safe</span>
          </h3>
          <p className="my-32 text-16-24 text-gray-600 md:max-w-xs">
            Get back control of your data. Humanloop Programmatic runs locally
            on your machine and no private data ever leaves.
            <br />
            <br />
            Since the data is labelled programmatically, you can even label data
            that no human ever needs to see.
          </p>

          <div className="my-16 rounded bg-gray-200 p-16 text-gray-700">
            Working with EHR data is incredibly sensitive so we love that
            Programmatic doesn&apos;t send our data to the cloud.
          </div>
          <AvatarProfile
            name={`Dr Bram Von Es`}
            company={"MedX AI"}
            image="/assets/customers/bram2.jpeg"
          />
        </div>
      </div>
    </div>
  );
};
